export const activateOktaUser = ({ token, userId }) => ({
  HTTPMethod: "patch",
  path: `/api/v1/sso/users/${userId}/status`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {
    data: {
      status: "ACTIVE",
    },
  },
});
